var _style, _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 60 60",
    style: {
      enableBackground: "new 0 0 60 60"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#A1A1A1;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M54.6,8.2h-3.9c-0.6,0-1-0.4-1-1V5.5c0-2.8-2.2-5-5-5H29.3c-2.8,0-5,2.2-5,5v1.8c0,0.6-0.4,1-1,1h-3.9 c-2.8,0-5,2.2-5,5V18c0,0.6,0.4,1,1,1h43.2c0.6,0,1-0.4,1-1v-4.7C59.6,10.5,57.4,8.2,54.6,8.2z M45.7,7.2c0,0.6-0.4,1-1,1H29.3 c-0.6,0-1-0.4-1-1V5.5c0-0.6,0.4-1,1-1h15.5c0.6,0,1,0.4,1,1v1.7H45.7z M54.4,21.5H19.6c-0.6,0-1,0.4-1,1v32c0,2.8,2.2,5,5,5h26.8 c2.8,0,5-2.2,5-5v-32C55.4,21.9,54.9,21.5,54.4,21.5z M28.9,52.5c0,1.1-0.9,2-2,2s-2-0.9-2-2V27.7c0-1.1,0.9-2,2-2s2,0.9,2,2V52.5z  M39,52.5c0,1.1-0.9,2-2,2c-1.1,0-2-0.9-2-2V27.7c0-1.1,0.9-2,2-2c1.1,0,2,0.9,2,2V52.5z M49.1,52.5c0,1.1-0.9,2-2,2s-2-0.9-2-2 V27.7c0-1.1,0.9-2,2-2s2,0.9,2,2V52.5z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.e0e33d5d0b01d87dacb605497a565e2b.svg";
export { ForwardRef as ReactComponent };